<ng-template #popContent class="connection-warning-popover">
    <fa-icon [icon]="faExclamationCircle" size="2x" />
    <div jhiTranslate="artemisApp.disconnectedAlert"></div>
    <jhi-close-circle (click)="popover.close()" />
</ng-template>
<div
    class="connection-warning"
    [ngClass]="{ disconnected: disconnected }"
    [ngbPopover]="popContent"
    popoverClass="connection-warning-popover"
    #popover="ngbPopover"
    [triggers]="'manual'"
    [placement]="'auto'"
    [autoClose]="false"
    (click)="popover?.toggle()"
>
    <fa-icon [icon]="faWifi" />
    @if (disconnected && !isOnExamParticipationPage) {
        <fa-icon id="pulse-icon" [icon]="faWifi" />
    }
</div>
